export const InsuRoutes = [
  {
    path: '/area-insu-buy-detail',
    name: 'AreaInsuBuyDetail',
    component: () =>
      import(
        '@/views/InsuDetail/AreaInsuBuyDetail' /* webpackChunkName: "jincheng-yibao-area-insu-buy-detail" */
      ),
    meta: {
      title: ''
    }
  },
  {
    path: '/insu-faq',
    name: 'InsuFaq',
    component: () =>
      import(
        '@/views/InsuDetail/InsuFaq' /* webpackChunkName: "jincheng-yibao-insu-faq" */
      ),
    meta: {
      title: '常见问题'
    }
  }
]
